// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var SftpForm$ReactHooksTemplate = require("./SftpForm.res.js");
var SftpSettings$ReactHooksTemplate = require("./SftpSettings.res.js");

var initialState = {
  configs: /* [] */0,
  loading: false,
  error: undefined,
  success: undefined,
  showForm: false,
  editingConfig: undefined,
  isEdit: false
};

function SftpConfigurations(props) {
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var fetchConfigs = function (param) {
    Curry._1(setState, (function (prev) {
            return {
                    configs: prev.configs,
                    loading: true,
                    error: prev.error,
                    success: prev.success,
                    showForm: prev.showForm,
                    editingConfig: prev.editingConfig,
                    isEdit: prev.isEdit
                  };
          }));
    Js_promise.$$catch((function (param) {
            Curry._1(setState, (function (prev) {
                    return {
                            configs: prev.configs,
                            loading: false,
                            error: "Failed to load SFTP Configurations",
                            success: prev.success,
                            showForm: prev.showForm,
                            editingConfig: prev.editingConfig,
                            isEdit: prev.isEdit
                          };
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (data) {
                Curry._1(setState, (function (prev) {
                        return {
                                configs: data,
                                loading: false,
                                error: prev.error,
                                success: prev.success,
                                showForm: prev.showForm,
                                editingConfig: prev.editingConfig,
                                isEdit: prev.isEdit
                              };
                      }));
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/sftp_configurations", (function (param) {
                    return Json_decode.list(SftpSettings$ReactHooksTemplate.fromJson, param);
                  }))));
  };
  React.useEffect((function (param) {
          fetchConfigs();
        }), []);
  var handleCreate = function (param) {
    Curry._1(setState, (function (prev) {
            return {
                    configs: prev.configs,
                    loading: prev.loading,
                    error: prev.error,
                    success: prev.success,
                    showForm: true,
                    editingConfig: SftpSettings$ReactHooksTemplate.initialConf,
                    isEdit: false
                  };
          }));
  };
  var handleFormChange = function (updated) {
    Curry._1(setState, (function (prev) {
            return {
                    configs: prev.configs,
                    loading: prev.loading,
                    error: prev.error,
                    success: prev.success,
                    showForm: prev.showForm,
                    editingConfig: updated,
                    isEdit: prev.isEdit
                  };
          }));
  };
  var buildSftpConfigDict = function (form) {
    var params = {};
    params["id"] = SftpSettings$ReactHooksTemplate.configId(form);
    params["name"] = SftpSettings$ReactHooksTemplate.name(form);
    params["host"] = SftpSettings$ReactHooksTemplate.host(form);
    params["port"] = SftpSettings$ReactHooksTemplate.port(form);
    params["username"] = SftpSettings$ReactHooksTemplate.username(form);
    var pw = SftpSettings$ReactHooksTemplate.password(form);
    params["password"] = pw !== undefined ? pw : "";
    params["active"] = SftpSettings$ReactHooksTemplate.isActive(form);
    return params;
  };
  var handleFormSubmit = function ($$event) {
    $$event.preventDefault();
    var config = state.editingConfig;
    if (config === undefined) {
      return ;
    }
    var method = state.isEdit ? (function (url, p) {
          return Http$ReactHooksTemplate.fetchPostJSON(url + "/update", p);
        }) : Http$ReactHooksTemplate.fetchPostJSON;
    var url = state.isEdit ? "/api/v1/sftp_configurations/" + String(SftpSettings$ReactHooksTemplate.configId(config)) : "/api/v1/sftp_configurations";
    var params = buildSftpConfigDict(config);
    Js_promise.$$catch((function (param) {
            Curry._1(setState, (function (prev) {
                    return {
                            configs: prev.configs,
                            loading: prev.loading,
                            error: "Failed to save SFTP Configuration",
                            success: prev.success,
                            showForm: prev.showForm,
                            editingConfig: prev.editingConfig,
                            isEdit: prev.isEdit
                          };
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (param) {
                Curry._1(setState, (function (prev) {
                        return {
                                configs: prev.configs,
                                loading: prev.loading,
                                error: prev.error,
                                success: state.isEdit ? "SFTP Configuration updated successfully" : "SFTP Configuration created successfully",
                                showForm: false,
                                editingConfig: undefined,
                                isEdit: prev.isEdit
                              };
                      }));
                fetchConfigs();
                return Promise.resolve();
              }), Curry._2(method, url, params)));
  };
  var handleCancel = function (param) {
    Curry._1(setState, (function (prev) {
            return {
                    configs: prev.configs,
                    loading: prev.loading,
                    error: prev.error,
                    success: prev.success,
                    showForm: false,
                    editingConfig: undefined,
                    isEdit: prev.isEdit
                  };
          }));
  };
  var clearMessages = function (param) {
    Curry._1(setState, (function (prev) {
            return {
                    configs: prev.configs,
                    loading: prev.loading,
                    error: undefined,
                    success: undefined,
                    showForm: prev.showForm,
                    editingConfig: prev.editingConfig,
                    isEdit: prev.isEdit
                  };
          }));
  };
  React.useEffect((function (param) {
          var match = state.error;
          var match$1 = state.success;
          if (match === undefined && match$1 === undefined) {
            return ;
          }
          var timer = setTimeout(clearMessages, 3000);
          return (function (param) {
                    clearTimeout(timer);
                  });
        }), [
        state.error,
        state.success
      ]);
  var error = state.error;
  var success = state.success;
  return JsxRuntime.jsxs("div", {
              children: [
                error !== undefined ? JsxRuntime.jsx("div", {
                        children: error,
                        className: "mx-20-px mt-20-px p-20-px bg-failure border border-firebrick text-firebrick rounded"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                success !== undefined ? JsxRuntime.jsx("div", {
                        children: success,
                        className: "mx-20-px mt-20-px p-20-px bg-success border border-americangreen text-americangreen rounded"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                state.showForm && state.editingConfig !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(SftpForm$ReactHooksTemplate.make, {
                              sftpConf: Belt_Option.getExn(state.editingConfig),
                              onChange: handleFormChange,
                              onSubmit: handleFormSubmit,
                              onCancel: handleCancel,
                              isEdit: state.isEdit
                            })
                      }) : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("h2", {
                                        children: "SFTP Configurations",
                                        className: "text-lg font-semibold text-darkcharcoal"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "h-14-px mr-2-px",
                                                src: Image$ReactHooksTemplate.plusCircle
                                              }),
                                          "Create New"
                                        ],
                                        className: "bg-ghostwhite border border-gray-400\n                shadow-inner flex rounded py-2 px-3 text-xs cursor-pointer",
                                        onClick: handleCreate
                                      })
                                ],
                                className: "flex justify-between items-center mb-6"
                              }),
                          state.loading ? JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("div", {
                                        children: "Loading...",
                                        className: "text-aurometalsaurus"
                                      }),
                                  className: "flex justify-center items-center py-8"
                                }) : (
                              Belt_List.length(state.configs) === 0 ? JsxRuntime.jsx("div", {
                                      children: "No SFTP Configurations configured yet.",
                                      className: "text-center py-8 text-aurometalsaurus"
                                    }) : JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("table", {
                                            children: [
                                              JsxRuntime.jsx("thead", {
                                                    children: JsxRuntime.jsxs("tr", {
                                                          children: [
                                                            JsxRuntime.jsx("th", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          "Name",
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "ml-4-px",
                                                                                src: Image$ReactHooksTemplate.heading
                                                                              })
                                                                        ],
                                                                        className: "flex"
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("th", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          "Host",
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "ml-4-px",
                                                                                src: Image$ReactHooksTemplate.heading
                                                                              })
                                                                        ],
                                                                        className: "flex"
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("th", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          "Port",
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "ml-4-px",
                                                                                src: Image$ReactHooksTemplate.heading
                                                                              })
                                                                        ],
                                                                        className: "flex"
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("th", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          "Username",
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "ml-4-px",
                                                                                src: Image$ReactHooksTemplate.heading
                                                                              })
                                                                        ],
                                                                        className: "flex"
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("th", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          "Active",
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "ml-4-px",
                                                                                src: Image$ReactHooksTemplate.heading
                                                                              })
                                                                        ],
                                                                        className: "flex"
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("th", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          "Actions",
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "ml-4-px",
                                                                                src: Image$ReactHooksTemplate.heading
                                                                              })
                                                                        ],
                                                                        className: "flex"
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                })
                                                          ]
                                                        }),
                                                    className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                                  }),
                                              JsxRuntime.jsx("tbody", {
                                                    children: $$Array.of_list(Belt_List.map(state.configs, (function (config) {
                                                                return JsxRuntime.jsxs("tr", {
                                                                            children: [
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: JsxRuntime.jsxs("div", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx("div", {
                                                                                                  children: JsxRuntime.jsx("div", {
                                                                                                        children: SftpSettings$ReactHooksTemplate.name(config)[0],
                                                                                                        className: "m-auto"
                                                                                                      }),
                                                                                                  className: "w-8 h-8 flex items-center text-white uppercase mr-3 rounded-lg bg-blue-500"
                                                                                                }),
                                                                                            JsxRuntime.jsxs("div", {
                                                                                                  children: [
                                                                                                    JsxRuntime.jsx("p", {
                                                                                                          children: SftpSettings$ReactHooksTemplate.name(config),
                                                                                                          className: "truncate max-w-150-px"
                                                                                                        }),
                                                                                                    JsxRuntime.jsx("div", {
                                                                                                          children: SftpSettings$ReactHooksTemplate.name(config),
                                                                                                          className: "tooltip-container-text"
                                                                                                        })
                                                                                                  ],
                                                                                                  className: SftpSettings$ReactHooksTemplate.name(config).length > 16 ? "tooltip-container" : ""
                                                                                                })
                                                                                          ],
                                                                                          className: "flex items-center"
                                                                                        }),
                                                                                    className: "px-4 py-3"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: SftpSettings$ReactHooksTemplate.host(config),
                                                                                    className: "px-4 py-3"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: SftpSettings$ReactHooksTemplate.port(config),
                                                                                    className: "px-4 py-3"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: SftpSettings$ReactHooksTemplate.username(config),
                                                                                    className: "px-4 py-3"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: JsxRuntime.jsx("span", {
                                                                                          children: SftpSettings$ReactHooksTemplate.isActive(config) ? "Active" : "Inactive",
                                                                                          className: SftpSettings$ReactHooksTemplate.isActive(config) ? "text-green-600 font-semibold" : "text-red-600 font-semibold"
                                                                                        }),
                                                                                    className: "px-4 py-3"
                                                                                  }),
                                                                              JsxRuntime.jsx("td", {
                                                                                    children: JsxRuntime.jsxs("div", {
                                                                                          children: [
                                                                                            JsxRuntime.jsx("button", {
                                                                                                  children: "Edit",
                                                                                                  className: "text-indigo-600 hover:text-indigo-800 text-sm font-medium",
                                                                                                  onClick: (function (param) {
                                                                                                      Curry._1(setState, (function (prev) {
                                                                                                              return {
                                                                                                                      configs: prev.configs,
                                                                                                                      loading: prev.loading,
                                                                                                                      error: prev.error,
                                                                                                                      success: prev.success,
                                                                                                                      showForm: true,
                                                                                                                      editingConfig: config,
                                                                                                                      isEdit: true
                                                                                                                    };
                                                                                                            }));
                                                                                                    })
                                                                                                }),
                                                                                            JsxRuntime.jsx("button", {
                                                                                                  children: "Delete",
                                                                                                  className: "text-firebrick hover:text-red-800 text-sm font-medium",
                                                                                                  onClick: (function (param) {
                                                                                                      var id = SftpSettings$ReactHooksTemplate.configId(config);
                                                                                                      if (Curry._1(confirm, "Are you sure you want to delete this SFTP configuration?")) {
                                                                                                        Js_promise.$$catch((function (param) {
                                                                                                                Curry._1(setState, (function (prev) {
                                                                                                                        return {
                                                                                                                                configs: prev.configs,
                                                                                                                                loading: prev.loading,
                                                                                                                                error: "Failed to delete SFTP Configuration",
                                                                                                                                success: prev.success,
                                                                                                                                showForm: prev.showForm,
                                                                                                                                editingConfig: prev.editingConfig,
                                                                                                                                isEdit: prev.isEdit
                                                                                                                              };
                                                                                                                      }));
                                                                                                                return Promise.resolve();
                                                                                                              }), Js_promise.then_((function (param) {
                                                                                                                    Curry._1(setState, (function (prev) {
                                                                                                                            return {
                                                                                                                                    configs: prev.configs,
                                                                                                                                    loading: prev.loading,
                                                                                                                                    error: prev.error,
                                                                                                                                    success: "SFTP Configuration deleted successfully",
                                                                                                                                    showForm: prev.showForm,
                                                                                                                                    editingConfig: prev.editingConfig,
                                                                                                                                    isEdit: prev.isEdit
                                                                                                                                  };
                                                                                                                          }));
                                                                                                                    fetchConfigs();
                                                                                                                    return Promise.resolve();
                                                                                                                  }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/sftp_configurations/" + String(id) + "/delete", {})));
                                                                                                        return ;
                                                                                                      }
                                                                                                      
                                                                                                    })
                                                                                                })
                                                                                          ],
                                                                                          className: "flex items-center space-x-2"
                                                                                        }),
                                                                                    className: "px-4 py-3"
                                                                                  })
                                                                            ],
                                                                            className: "border-b border-bottom-gray-600"
                                                                          }, String(SftpSettings$ReactHooksTemplate.configId(config)));
                                                              })))
                                                  })
                                            ],
                                            className: "text-left table-auto w-full border-separate text-sm font-medium"
                                          }),
                                      className: "w-full"
                                    })
                            )
                        ],
                        className: "p-8"
                      })
              ]
            });
}

var make = SftpConfigurations;

exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
